/* prettier-ignore */

import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/auth/services';
import { ToolsService } from 'src/app/services/tools.service';
import { RegisterComponent } from '../register/register.component';
import { RestService } from 'src/app/services/rest.service';
import { UserService } from 'src/app/user/services';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})

export class LoginComponent {
  private _authService = inject(AuthService);
  
    passwordType: any = 'password';
    public loginForm = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email]),
        password: new FormControl('', [Validators.required, Validators.minLength(6)]),
        remember: new FormControl(false),
    });
    
  constructor(
    public rest: RestService,
    public modalCtrl: ModalController, 
    public userService: UserService,
    public tools: ToolsService,
    public translate: TranslateService,
  ) {}
  
  protected login(): void {
    const userEmail = this.loginForm.get('email')?.value;
    const userPassword = this.loginForm.get('password')?.value;
    
    this._authService.loginServiceSignal(userEmail, userPassword);
  }

  dismissModal(){
    this.modalCtrl.dismiss().catch(e => {
      console.warn("No modal found on dismiss")
    });
  }

  showPassword(){
    this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
  }

  getIconStatus(){
    return this.passwordType === 'password' ? 'eye-off' : 'eye'
  }

  focusin(evt) {
    evt.stopPropagation();
  } 

  async register(){
    this.modalCtrl.dismiss().catch(e => {
      console.warn("No modal found on dismiss")
    });

    const registerModal = await this.modalCtrl.create({
        component: RegisterComponent,
        cssClass: ['registerModal', 'ion-disable-focus-trap'],
    });
    await registerModal.present();
  }

  recoverPassword(){
    const url = `${this.rest.apiUrlBase}/api/forgot-password`
    window.open(url, "_blank");
  }
}